import { Component, Vue, Watch, Prop, Ref } from 'vue-property-decorator'
import projectsService from '@/projects/services/projects-service'
import PaginationRequest from '@/common/pagination/entities/pagination-request'
import CreateProjectDialog from '@/projects/components/create-project-dialog/create-project-dialog'
import Project from '@/projects/entities/project'
import foldersService from '@/folders/services/folders-service'
import Folder from '@/folders/entities/folder'

// TODO: registring the hook globally does not work.
Component.registerHooks(['beforeRouteEnter'])

@Component
export default class Projects extends Vue {
  @Ref()
  private createProjectDialog!: CreateProjectDialog

  private search = ''
  private pagination = new PaginationRequest(8)
  private projects: any[] = []
  private folders: Folder[] = []
  private showArchivedProjects = false
  private loading = false

  private activeTab = ''

  @Watch('showArchivedProjects')
  private async showArchivedProjectsChangedAsync() {
    await this.fetchProjectsAsync()
  }

  private async fetchProjectsAsync() {
    this.loading = true
    await this.loadFoldersAsync()
    const res = await projectsService.findAllAsync(
      this.search,
      this.showArchivedProjects,
      this.pagination,
      this.activeTab === 'Nicht zugeordnet' ? null : this.activeTab
    )
    this.projects = res.items
    this.pagination.totalItems = res.totalItems
    this.loading = false
  }

  private openCreateProjectDialog() {
    this.createProjectDialog.create(new Project())
  }

  private async openEditProjectDialog(project: Project) {
    this.createProjectDialog.edit(project)
  }

  private async createProject(project: Project) {
    const p = await projectsService.createAsync(project)
    if (p && project.image.size > 0) {
      project.id = p.id
      await projectsService.updateImageAsync(project)
    }
    await this.fetchProjectsAsync()

    this.createProjectDialog.close()
  }

  private async updateProject(project: Project) {
    await projectsService.updateAsync(project)
    await projectsService.updateImageAsync(project)
    await this.fetchProjectsAsync()

    this.createProjectDialog.close()
  }

  private async archiveProject(project: Project) {
    await projectsService.updateStatusAsync(project.id, 2)
    await this.fetchProjectsAsync()
  }

  private async activateProject(project: Project) {
    await projectsService.updateStatusAsync(project.id, 1)
    await this.fetchProjectsAsync()
  }

  private async duplicateProject(project: Project) {
    await projectsService.duplicateAsync(project.id, 2)
    await this.fetchProjectsAsync()
  }

  private async created() {
    this.pagination.sortBy = ['name']
    this.pagination.sortDesc = [false]
    await this.fetchProjectsAsync()
  }

  private beforeRouteEnter(to: any, from: any, next: any) {
    next((vm: Vue) => vm.$bus.$emit('sidemenu:mode', 'menu'))
  }

  private async mounted() {
    await this.loadFoldersAsync()
  }

  private async loadFoldersAsync() {
    this.folders = await foldersService.findGrouped(
      this.search,
      this.showArchivedProjects
    )
  }

  @Watch('activeTab')
  private async activeTabChanged() {
    console.log('activeTabChanged: ', this.activeTab)
    await this.fetchProjectsAsync()
  }
}
